<template>
	<div class="maintenance">
		<div class="maintenance-container">
			<div class="maintenance-content">
				<div class="form-content">
					<el-form
						ref="maintenanceForm"
						:model="maintenanceForm"
						:rules="rules"
						:disabled="!isSetting"
						label-width="340px"
						label-position="right"
					>
						<div class="section-header">
							<h4>材料</h4>
						</div>

						<div class="form-row">
							<el-form-item label="房地产开发资质证书编号：" prop="certificateCode" class="form-item center-item">
								<el-input v-model="maintenanceForm.certificateCode" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="批准从事房地产开发经营业务的房地产开发主管部门：" prop="approvalUnit" class="form-item">
								<el-input v-model="maintenanceForm.approvalUnit" placeholder=""></el-input>
							</el-form-item>
						</div>
						<div class="form-row">
							<el-form-item label="质批准从事房地产开发经营业务房地产开发批准时间：" prop="approvalDate" class="form-item">
								<el-date-picker
									v-model="maintenanceForm.approvalDate"
									type="date"
									value-format="yyyy-MM-dd"
									style="width: 100%;"
								></el-date-picker>
							</el-form-item>
							<el-form-item label="近3年房屋建筑面积累计竣工：" prop="completedAreaOfThreeYear" class="form-item center-item">
								<el-input v-model="maintenanceForm.completedAreaOfThreeYear" v-positiveNumber placeholder="">
									<template slot="append">万平方米</template>
								</el-input>
							</el-form-item>
						</div>
						<div class="form-row">
							<el-form-item label="上年度房屋建筑施工面积：" prop="constructionAreaOfLastYear" class="form-item center-item">
								<el-input v-model="maintenanceForm.constructionAreaOfLastYear" v-positiveNumber placeholder="">
									<template slot="append">万平方米</template>
								</el-input>
							</el-form-item>
							<el-form-item label="近5年建筑工程质量合格率：" prop="passRateOfFiveYearList" class="form-item center-item">
								<el-select
									v-model="passRateOfFiveYear"
									placeholder=""
									style="width: 26%;margin-right: 10px;"
									@change="handleGetRateValue"
								>
									<el-option v-for="year in yearOptions" :key="year" :label="year" :value="year"></el-option>
								</el-select>
								<el-input
									v-model="passRateOfFiveValue"
									v-oneToHundredInteger
									placeholder=""
									style="width: 69%;"
									@blur="handleAddRateValue"
								>
									<template slot="append">%</template>
								</el-input>
							</el-form-item>
						</div>
						<div class="form-row">
							<el-form-item label="是否有完善的质量保证体系：" prop="whetherQualitySystem" class="form-item center-item">
								<el-radio-group v-model="maintenanceForm.whetherQualitySystem">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item
								label="是否有《住宅质量保证书》执行情况报告："
								prop="whetherInstructionReport"
								class="form-item center-item"
							>
								<el-radio-group v-model="maintenanceForm.whetherInstructionReport">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
						<div class="form-row">
							<el-form-item
								label="是否有《住宅使用说明书》执行情况报告："
								prop="whetherWarrantyReport"
								class="form-item center-item"
							>
								<el-radio-group v-model="maintenanceForm.whetherWarrantyReport">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
					</el-form>
					<div class="section-header">
						<h4>专业管理人员</h4>
						<el-button v-if="isSetting" type="primary" @click="handleAddPerson">
							添加人员
						</el-button>
					</div>
					<div>
						<!-- 数据表格 -->
						<data-table
							:table-data="personnelData"
							:column="personnelColumns"
							:loading="personLoading"
							:page-options="pageOptions"
							:border="true"
							:selection="false"
							:index="true"
							@page-change="pager => handlePageChange(pager)"
						>
							<!-- 操作列 -->
							<template slot="slot_action" slot-scope="{ scope }">
								<el-button v-if="isSetting" type="text" @click="handleDelete(scope.row.id)">
									删除
								</el-button>
								<el-button v-if="isSetting" type="text" @click="handleEditPerson(scope.row)">
									编辑
								</el-button>
							</template>
						</data-table>
					</div>
				</div>
			</div>

			<div v-if="isSetting && !isDiagnostic" class="maintenance-footer">
				<el-button type="primary" @click="handleSaveMaterial">保 存</el-button>
			</div>

			<!-- 未绑定企业遮罩层 -->
			<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-else-if="isNormalVip"></nonbind-vip>
		</div>

		<!-- 添加专业管理人员 -->
		<jr-dialog :visible.sync="addPersonDialog" :title="title" width="72%" :append-to-body="true">
			<template v-if="addPersonDialog" slot="content">
				<professional-management ref="professionalManagement"></professional-management>
			</template>
			<template slot="footer">
				<el-button @click="addPersonDialog = false">取 消</el-button>
				<el-button type="primary" :loading="addPersonLoading" @click="handleSaveForm">确 定</el-button>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import DataTable from '@/components/JrTable/DataTable'
	import ProfessionalManagement from '../components/professionalManagement.vue'
	import NonbindVip from '@/components/NonBind/nonbindVip'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import { transObject } from '@/utils'
	import { mapGetters } from 'vuex'
	import {
		getRealtyKfMaterialRecordGetById,
		realtyKfMaterialRecordSaveOrUpdate,
		getRealtyKfRyPagerList,
		realtyKfRySaveOrUpdate,
		removeById
	} from '@/api/realEstate/materialRecord'

	// 工程监理资质材料维护
	export default {
		name: 'RealEstateDevelopmentMaintenance',
		components: {
			JrDialog,
			ProfessionalManagement,
			NonbindVip,
			NonbindEnterprise,
			DataTable
		},
		props: {
			// 是否开启配置
			isSetting: {
				type: Boolean,
				default: false
			},
			// 是否是诊断提交材料处打开，主要用于控制“保存“是否显示
			isDiagnostic: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// 诊断记录id
				diagnosisRecordId: '',
				// 房地产材料
				// 近五年下拉数据
				yearOptions: (() => {
					const currentYear = new Date().getFullYear() - 1 // 使用上一年作为基准
					return Array.from({ length: 5 }, (_, i) => String(currentYear - i)) // 转为字符串
				})(),
				// 近五年合格率年份
				passRateOfFiveYear: '',
				// 近五年合格率数值
				passRateOfFiveValue: '',
				maintenanceForm: {
					id: '', // 主键
					certificateCode: '', // 房地产开发资质证书编号：
					approvalUnit: '', // 批准从事房地产开发经营业务的房地产开发主管部门：
					approvalDate: '', // 质批准从事房地产开发经营业务房地产开发批准时间：
					completedAreaOfThreeYear: '', // 近3年房屋建筑面积累计竣工：
					constructionAreaOfLastYear: '', // 上年度房屋建筑施工面积：
					passRateOfFiveYearList: [], // 近5年建筑工程质量合格率：
					whetherQualitySystem: '', // 是否有完善的质量保证体系：
					whetherInstructionReport: '', // 是否有《住宅质量保证书》执行情况报告：
					whetherWarrantyReport: '' // 是否有《住宅使用说明书》执行情况报告：
				},
				rules: {
					certificateCode: [{ required: true, trigger: 'blur', message: '请输入' }],
					approvalUnit: [{ required: true, trigger: 'blur', message: '请输入' }],
					approvalDate: [{ required: true, trigger: 'change', message: '请选择' }],
					completedAreaOfThreeYear: [{ required: true, trigger: 'blur', message: '请输入' }],
					constructionAreaOfLastYear: [{ required: true, trigger: 'change', message: '请输入' }],
					passRateOfFiveYearList: [{ required: true, trigger: 'blur', message: '请输入' }],
					whetherQualitySystem: [{ required: true, trigger: 'change', message: '请选择' }],
					whetherInstructionReport: [{ required: true, trigger: 'change', message: '请选择' }],
					whetherWarrantyReport: [{ required: true, trigger: 'change', message: '请选择' }]
				},

				// 专业管理人员信息
				personnelData: [],
				personnelColumns: [
					{ prop: 'name', label: '姓名', minWidth: '100' },
					{ prop: 'zjhm', label: '身份证号', minWidth: '180' },
					{ prop: 'lb', label: '类别', minWidth: '120' },
					{ prop: 'zc', label: '职称等级', minWidth: '120' },
					{ prop: 'zy', label: '职称专业', minWidth: '120' },
					{ prop: '', label: '操作', align: 'center', slot: 'slot_action', width: '150', isHidden: false }
				],
				pageOptions: { page: 1, limit: 10, total: 0 },
				personLoading: false,

				// 添加专业管理人员
				addPersonDialog: false,
				title: '',
				addPersonLoading: false
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip'])
		},
		watch: {
			isSetting: {
				immediate: true,
				handler(newVal) {
					this.personnelColumns = this.personnelColumns.map(item => {
						if (item.slot === 'slot_action') {
							return {
								...item,
								isHidden: !newVal
							}
						}
						return item
					})
				}
			}
		},
		created() {},
		mounted() {
			// 获取诊断记录对应的记录id
			this.diagnosisRecordId = this.$route.query && this.$route.query.recordId
			if (this.isHasCompany && (this.isVip || this.isSVip)) {
				this.initMaterialInfo()
				this.initList()
			}
		},
		methods: {
			// 初始化材料信息
			initMaterialInfo() {
				let params = {
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}
				getRealtyKfMaterialRecordGetById(params).then(res => {
					transObject(res.data, this.maintenanceForm)
					const foundItem = this.maintenanceForm.passRateOfFiveYearList.find(item => item.year === this.yearOptions[0])
					if (foundItem) {
						this.passRateOfFiveYear = foundItem.year
						this.passRateOfFiveValue = foundItem.passRate
					}
				})
			},
			// 专业管理人员信息初始化
			initList() {
				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}
				getRealtyKfRyPagerList(params)
					.then(res => {
						this.personnelData = res.data.records
						this.pageOptions.total = res.data.total
						this.personLoading = false
					})
					.catch(err => {
						this.personLoading = false
					})
			},
			// 翻页
			handlePageChange(pager) {
				const { page, limit } = pager
				this.pageOptions.currentPage = page
				this.pageOptions.limit = limit
				this.initList()
			},

			// 材料信息维护
			// 根据不同年份回显不同年份数据
			handleGetRateValue() {
				// 根据当前选择的年份查找对应的值
				const foundItem = this.maintenanceForm.passRateOfFiveYearList.find(item => item.year === this.passRateOfFiveYear)
				console.log(this.maintenanceForm.passRateOfFiveYearList, this.passRateOfFiveYear)

				// 如果找到对应年份的数据，则回显值；否则清空
				this.passRateOfFiveValue = foundItem ? foundItem.passRate : ''
			},
			// 添加近五年数据
			handleAddRateValue() {
				// 检查是否已存在相同年份的数据
				const existingIndex = this.maintenanceForm.passRateOfFiveYearList.findIndex(item => item.year === this.passRateOfFiveYear)

				const newData = {
					year: this.passRateOfFiveYear,
					passRate: this.passRateOfFiveValue
				}

				if (existingIndex >= 0) {
					// 如果存在相同年份，则替换原有数据
					this.maintenanceForm.passRateOfFiveYearList.splice(existingIndex, 1, newData)
					this.$message.success('已更新该年份数据')
				} else {
					// 如果不存在相同年份，则添加新数据
					this.maintenanceForm.passRateOfFiveYearList.push(newData)
					this.$message.success('已添加新数据')
				}
			},

			// 人员信息维护

			// 校验人员数据
			validatePersonnelData() {
				const personnelCount = {
					gcjsfzr: 0,
					cwfzr: 0
				}

				// 统计各类别数量
				this.personnelData.forEach(person => {
					if (person.lb === '工程技术负责人') {
						personnelCount['gcjsfzr']++
					} else if (person.lb === '财务负责人') {
						personnelCount['cwfzr']++
					}
				})

				// 检查数量限制
				if (personnelCount['gcjsfzr'] > 1) {
					return {
						valid: false,
						message: '工程技术负责人最多只能有1个'
					}
				}

				if (personnelCount['cwfzr'] > 1) {
					return {
						valid: false,
						message: '财务负责人最多只能有1个'
					}
				}

				return { valid: true }
			},
			// 添加专业管理人员
			handleAddPerson() {
				this.title = '新增专业管理人员'
				this.addPersonDialog = true
			},
			// 编辑专业管理人员
			handleEditPerson(row) {
				this.title = '编辑专业管理人员'
				this.addPersonDialog = true
				this.$nextTick(() => {
					this.$refs.professionalManagement.form = row
				})
			},
			// 保存专业管理人员
			handleSaveForm() {
				// 校验负责人数量
				const checkResult = this.validatePersonnelData()
				if (!checkResult.valid) {
					this.$message.error(checkResult.message)
					return
				}
				this.$refs.professionalManagement.handleSaveInfo().then(res => {
					this.addPersonDialog = false

					realtyKfRySaveOrUpdate(res).then(response => {
						this.$message.success('新增成功')
						this.initList()
					})
				})
			},
			// 删除专业管理人员
			handleDelete(id) {
				const pramas = {
					id: id
				}
				this.$modal
					.confirm('请确认是否删除该人员信息？')
					.then(() => {
						return removeById(pramas)
					})
					.then(() => {
						this.$modal.msgSuccess('删除成功')
						this.initList()
					})
					.catch(() => {})
			},

			// 保存材料
			saveMaintenanceInfoPromise() {
				// 检查近五年数据是否完整
				const missingYears = []
				this.yearOptions.forEach(year => {
					const found = this.maintenanceForm.passRateOfFiveYearList.find(item => item.year === year && item.passRate)
					if (!found) {
						missingYears.push(year)
					}
				})
				if (missingYears.length > 0) {
					this.$message.error(`请填写以下年份的合格率数据：${missingYears.join('，')}`)
				}
				// 校验表单与人员数据
				const checkResult = this.validatePersonnelData()
				if (!checkResult.valid) {
					this.$message.error(checkResult.message)
				}
				return new Promise((resolve, reject) => {
					this.$refs.maintenanceForm.validate().then(valid => {
						console.log('valid:', valid, checkResult.valid, missingYears.length === 0)

						if (valid && checkResult.valid && missingYears.length === 0) {
							realtyKfMaterialRecordSaveOrUpdate(this.maintenanceForm).then(res => {
								this.initMaterialInfo()
								this.$message.success('保存成功')
								resolve()
							})
						} else {
							reject()
						}
					})
				})
			},
			handleSaveMaterial() {
				// 检查近五年数据是否完整
				const missingYears = []
				this.yearOptions.forEach(year => {
					const found = this.maintenanceForm.passRateOfFiveYearList.find(item => item.year === year && item.passRate)
					if (!found) {
						missingYears.push(year)
					}
				})
				if (missingYears.length > 0) {
					this.$message.error(`请填写以下年份的合格率数据：${missingYears.join('，')}`)
					return
				}
				// 校验表单与人员数据
				const checkResult = this.validatePersonnelData()
				if (!checkResult.valid) {
					this.$message.error(checkResult.message)
					return
				}
				this.$refs.maintenanceForm.validate().then(valid => {
					if (valid) {
						realtyKfMaterialRecordSaveOrUpdate(this.maintenanceForm).then(res => {
							this.initMaterialInfo()
							this.$message.success('保存成功')
						})
					}
				})
			},
			// 验证资质诊断材料是否维护
			handleValidMaintenanceInfoIsSetting() {
				// 从 rules 对象中提取所有必填字段
				const requiredFields = Object.entries(this.rules)
					.filter(([field, validators]) => validators.some(v => v.required === true))
					.map(([field]) => field)

				console.log('requiredFields:', requiredFields)

				const clFlag = requiredFields.every(field => {
					const value = this.maintenanceForm[field]
					return value !== undefined && value !== null && value !== ''
				})

				// 检查所有必填字段是否有值
				return clFlag && this.personnelData.length > 0
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';

	.maintenance {
		// padding: 20px;

		.maintenance-container {
			background-color: #fff;
			border-radius: 4px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			position: relative;

			.maintenance-content {
				// display: flex;
				min-height: 600px;
				padding: 20px;

				.section-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 15px;
					position: relative;

					h4 {
						margin: 0;
						font-size: 16px;
						font-weight: 500;
						color: #333;
						display: flex;
						justify-content: flex-start;

						&::before {
							content: '';
							display: block;
							width: 4px;
							margin-right: 10px;
							background: #2671cb;
						}
					}
				}
			}

			.maintenance-footer {
				text-align: center;
				padding-bottom: 20px;

				.el-button--primary {
					width: 100px;
				}
			}
		}
	}

	.form-content {
		.form-row {
			display: flex;
			gap: 20px;
		}
		.form-item {
			flex: 1;
			margin-bottom: 20px;

			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 15px;
					}
				}
				.el-date-editor--date {
					.el-input__inner {
						padding-left: 40px;
					}
				}
				.el-form-item__label {
					line-height: 22px;
				}
			}
		}
		.center-item {
			::v-deep {
				.el-form-item__label {
					line-height: 40px;
				}
			}
		}
	}
</style>
